import { Box, Typography, Button, } from '@mui/material';
import { styled, } from '@mui/system';

// STYLE START
export const ChatBoxWrap = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'stretch',
  flex: 1,
  minHeight: 0,
  padding: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    alignItems: 'center',
  },
}));
export const ChatBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minHeight: 0,
  backgroundColor: '#ecf0f4',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  border: 0,
  margin: 'auto',
  [theme.breakpoints.up('sm')]: {
    border: '1px solid rgba(0, 47, 115, 0.14)',
    borderRadius: 20,
    boxShadow: '0 24px 70px rgba(0, 47, 115, 0.15)',
    height: 'min(720px, calc(100dvh - 120px))',
    minHeight: 520,
  },
}));

export const ChatBoxHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  backgroundColor: '#fff',
  borderBottom: '1px solid rgba(0, 47, 115, 0.09)',
  minHeight: 64,
}));

export const ChatCompanyLogo = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  height: '36px',
  width: '36px',
  backgroundColor: '#fff',
  borderRadius: '100px',
  overflow: 'hidden',
  border: '1px solid #c9cdd0',
  '&.userImage':{
    // padding: theme.spacing(1),
    height: '36px',
    width: '36px',
    flex: '0 0 36px',
    marginRight: theme.spacing(1),
  },
  '& img':{
    display: 'block',
    float: 'left',
    height: '100%',
    width: '100%',
    // maxHeight: '100%',
    // maxWidth: '100%',
    objectFit: 'cover',
    objectPosition: 'top center',
  },
}));

export const ChatCompanyName = styled(Typography)(({ theme }) => ({
  display: 'inline-flex',
  paddingLeft: theme.spacing(1.25),
  overflow: 'hidden',
  color: theme.palette.primary.main,
  fontSize: '17px',
  fontWeight: '600',
}));

export const ChatBoxBody = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  minHeight: 0,
  padding: theme.spacing(2),
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  flexDirection: 'column',
  fontSize: '0.875rem',
}));

export const ChatMsgListing = styled(Box)(({  }) => ({
  display:  'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
}));

export const ChatMssList = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'flex-start',
  maxWidth: '100%',
  position: 'relative',
  paddingLeft: theme.spacing(5.25),
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(4.5),
    '&.user': {
      paddingRight: theme.spacing(4.5),
    },
  },
  '& .userImage':{
    position: 'absolute',
    top: 0,
    left: 0,
    margin: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  '&.user':{
    alignSelf: 'flex-end',
    flexFlow: 'column',
    alignItems: 'flex-end',
    paddingRight: theme.spacing(5.25),
    paddingLeft: 0,
    '& .userImage':{
      left: 'auto',
      right: 0,
      '& img':{
        width: 'auto',
        maxWidth: 30,
        height: 'auto',
        opacity: 0.7,
      },
    },
    '& > .MuiBox-root:first-of-type':{
      marginRight: 0,
      marginLeft: theme.spacing(1),
    },
    '& > .MuiBox-root:nth-of-type(2)':{
      minWidth: '1px',
      borderRadius: '10px 0 10px 10px',
      color: '#fff',
      backgroundColor: '#3062d0',
    }
  },
}));

export const ChatMssListBox = styled(Box)(({ theme }) => ({
  display:  'inline-flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  borderRadius: '0 10px 10px 10px',
  boxShadow: '0 1px 3px 0px rgba(1,28,70,0.2)',
  maxWidth: '100%',
  minWidth: 0,
  '&:not(.user)':{    
    minWidth: '160px',
  },
  '&.user':{
    alignSelf: 'flex-end',
    borderRadius: '10px 0 10px 10px',
    color: '#fff',
    backgroundColor: '#3062d0',
  },
  '& .chatMsgTable':{
    width: '100%',
    '& tr':{
      padding: theme.spacing(0, 1.5),
    },
    '& th':{
      padding: theme.spacing(1, 1),
      fontSize: 14,
      lineHeight: '18px',      
      borderLeft: '1px solid #4c80cc',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      borderRadius: '0 8px 0 0',
      '&:first-of-type':{
        borderLeft: 'none',
        borderRadius: '8px 0 0 0',
      }
    },
    '& td':{
      padding: theme.spacing(1, 1),
      fontSize: 13,
      lineHeight: '18px',
      fontWeight: 500,
      borderTop: '1px solid #ddd',
      borderLeft: '1px solid #ddd',
      // color: '#3d3d3d',
      color: theme.palette.primary.main,
      '&:first-of-type':{
        borderLeft: 'none',
        color: theme.palette.primary.main,
        fontWeight: 600,
      },
      '& span':{
        display: 'block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // maxWidth: '45ch',
      },
    },
  }
}));

export const ChatMsg = styled(Box)(({ theme }) => ({
  display:  'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: theme.spacing(1.75,  1.25),  
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight: '500',
}));

export const ChatMsgOptions = styled(Button)(({ theme }) => ({
  display:  'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1,  1.25),  
  fontSize: '14px',
  lineHeight: '18px',
  minHeight: '38px',
  fontWeight: '500',
  color: '#3062d0',
  borderTop: '1px solid #ddd',
  '&:last-child':{
    borderRadius: '0 0 10px 10px',
  }
}));

export const ChatBoxFooter = styled(Box)(({ theme }) => ({
  display:  'flex',
  flexWrap: 'wrap',
  padding: theme.spacing(0),  
  backgroundColor: '#ecf0f4',
  position: 'relative',
  paddingRight: theme.spacing(1),
  paddingLeft: theme.spacing(1),
  paddingTop: theme.spacing(1),
  paddingBottom: `max(${theme.spacing(1)}, env(safe-area-inset-bottom))`,
  borderTop: '1px solid #c1c4c8',
  '& form':{
    display: 'flex',
    width: '100%',
    // flexDirection: 'column', 
    alignItems: 'stretch', 
    gap: 1,
    '& > .MuiIconButton-root':{
      backgroundColor: '#3062d0',
      width: 54,
      height: 54,
      borderRadius: 100,
      alignSelf: 'center',
      marginLeft: theme.spacing(1),
      '& img':{
        width: 20,
        filter: 'brightness(0) invert(1)',
      },
    },
  },
  '& .MuiInputBase-root':{
    margin: '0 !important',
    background: 'transparent !important',
    borderRadius: '0px !important',
    border: 'none',
    '& .MuiInputBase-input':{
      backgroundColor: '#fff',
      minHeight: '54px !important',
      borderRadius: 100,
      paddingRight: '54px !important',
    },
    '& fieldset':{
      border: 'none !important',
    }
  },
  [theme.breakpoints.down('sm')]: {
    '& form > .MuiIconButton-root': {
      height: 48,
      width: 48,
    },
    '& .MuiInputBase-root .MuiInputBase-input': {
      minHeight: '48px !important',
    },
  },
  

}));

export const ChatFooterOptions = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  position: 'absolute',
  top: 16,
  right: 80,
  [theme.breakpoints.down('sm')]: {
    right: 68,
  },
}));


export const ChatAttachments = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  margin: theme.spacing(-0.4),
}));

export const ChatAttachmentCol = styled(Box)(({ theme }) => ({
  display: 'flex',
  float: 'left',
  justifyContent: 'center',
  alignItems: 'center',
  width: 48,
  height: 48,
  margin: theme.spacing(0.4),
  backgroundColor: '#fff',
  border: '1px solid #485052',
  borderRadius: 8,
  cursor: 'pointer',
  position: 'relative',
  // overflow: 'hidden',
  '&:before': {
    content: '""',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'absolute',
    top: 0,
    left: 0,
    transition: '500ms',
    opacity: '0',
    visibility: 'hidden',
  },
  '&:not(.counterOnly):hover:before': {
    opacity: '1',
    visibility: 'visible',
  },
  '&.counterOnly':{
    cursor: 'default',
    fontWeight: 600,
  },
  '& img': {
    display: 'block',
    width: 'auto',
    maxWidth: '100%',
    height: 'auto',
    maxHeight: '100%',
    '&.icon': {
      maxWidth: '32px',
      maxHeight: '32px',
    }
  },
  '& .close':{
    padding: 0,
    margin: 0,
    backgroundColor: '#505050',
    minWidth: '1px !important',
    minHeight: '1px !important',
    width: '16px',
    height: '16px',
    borderRadius: 100,
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    '&:hover':{
      backgroundColor: '#ff0e0e',
    },
    '& img':{
      filter: 'brightness(0) invert(1)',
      width: '12px',
      height: 'auto',
    },
  },
}));

export const ChatAttachmentCount = styled(Box)(({  }) => ({
  display: 'flex',
  float: 'left',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0,0,0,0.6)',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 500,
}));

export const ChatAttachmentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  margin: theme.spacing(-1.25),
}));

export const CurrentAttachments = styled(Box)(({  }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  gap: 1.5,
  mt: 1,
}));

export const CurrentAttachmentBox = styled(Box)(({  }) => ({
  display: 'flex',
  flex: '0 0 40px',
  minWidth: '40px',
  maxWidth: '40px',
  height: 40,
  background: '#fff',
  border: '1px solid #d8dbdd',
  borderRadius: 0.5,
}));

